import { cloneDeep } from 'lodash';

var columnSettings = {
  name: {
    name: 'name',
    sort: 'asc',
    defaultSort: 'asc',
    displayName: 'TABLE_HEADER_COL_NAME',
  },
  email: {
    name: 'email',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_EMAIL',
  },
  role: {
    name: 'role',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_ROLE'
  },
  invite: {
    name: 'invite',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_INVITATION'
  },
  canExportReport: {
    name: 'canExportReport',
    class: 'text-center',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_CAN_EXPORT',
  },
};

var defaultColumns = ['name', 'email', 'role', 'invite', 'canExportReport'];

export default class AccountUserService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = [...defaultColumns];
  }

  getAccountUsers(accountId) {
    var url = this.#getBaseUrl(accountId) + '?includeAllRoles=true';
    return this.$http.get(url).then((response) => {
      var users = response.data.users.map(function (user) {
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });
      return users;
    });
  }

  getAuthenticationType() {
    var url = this.ngAuthSettings.apiServiceBaseUri + 'profile/getAuthenticationType';
    return this.$http.get(url);
  }

  createAccountUser(accountId, user) {
    var url = this.#getBaseUrl(accountId);
    return this.$http.put(url, user);
  }

  deleteAccountUser(accountId, userId) {
    var url = this.#getBaseUrl(accountId, userId);
    return this.$http.delete(url);
  }

  #getBaseUrl(accountId, userId) {
    return this.ngAuthSettings.apiServiceBaseUri + 'ringbaaccounts/' + accountId + '/users' + (userId ? '/' + userId : '');
  }
}